import { authActionTypes, SetIsLoading, SetOauthPending } from 'Types/AuthTypes';

export const setTempSignUpPass = (payload: string | undefined) => ({
  type: authActionTypes.SET_TEMP_SIGNUP_PASS,
  payload,
});

export const setIsAuthenticated = (payload: boolean) => ({
  type: authActionTypes.SET_IS_AUTHENTICATED,
  payload,
});

export const setPendingEmailOrPhone = (payload: string) => ({
  type: authActionTypes.SET_PENDING_EMAIL_OR_PHONE,
  payload,
});

export const clearAuthData = () => ({
  type: authActionTypes.CLEAR_DATA,
});

export function setIsLoading(isLoading: boolean): SetIsLoading {
  return {
    type: authActionTypes.SET_IS_LOADING,
    payload: isLoading,
  };
}

export function setOauthPending(oauthPending: boolean): SetOauthPending {
  return {
    type: authActionTypes.SET_OAUTH_PENDING,
    payload: oauthPending,
  };
}
